import { Router } from '@angular/router';
import { FlamingoAuthService } from '../@flamingo/service/flamingo-auth.service';
import { MainService } from './core/service/main.service';
import { AccountView } from './core/model/account-view.model';
import { UserType } from './core/model/user.model';

export function initializeApp(
    authService: FlamingoAuthService,
    mainService: MainService,
    router: Router,
): () => Promise<void> {
    return (): Promise<void> => {
        return new Promise((resolve, reject) => {
            console.log('Startup App');
            const token = authService.getToken();
            if (token) {
                authService.updateUserFromToken();
                mainService.getAccount()
                    .subscribe(
                        (res: any) => {
                            // logout if change role
                            if (authService.user?.type !== res.profileType) {
                                authService.logout();
                                router.navigate(['/auth']);
                            }

                            mainService.user = res as AccountView;
                            resolve();
                        },
                        (_: any) => {
                            authService.logout();
                            resolve();
                        },
                    );
            } else {
                resolve();
            }
        });
    };
}
